import { ScreenScanPage } from '@hq/screen-scan';
import { hq } from '../session';

/**
 * 申请码确认（PC 端，SUPPLIER 门户）：
 * 输入大屏上显示的 12 位申请码（4-4-4 三段），当前登录账号直接确认；
 * 授权范围由令牌绑定的供应商主体决定（服务端按 sid 收口，不接受客户端指定）。
 */
export default function ScreenScan() {
  return <ScreenScanPage hq={hq} />;
}
